// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App-level overrides (kept minimal — main theme in index.css) */
.App { min-height: 100vh; }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE,OAAO,iBAAiB,EAAE","sourcesContent":["/* App-level overrides (kept minimal — main theme in index.css) */\n.App { min-height: 100vh; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
